import { listLabels, getLabel, deleteLabel, createLabel, updateLabel, queryLabels, countLabels } from '@wix/ambassador-restaurants-menus-v1-item-label/http';
import { BaseAPIClient } from './BaseAPIClient';
export class LabelsClient extends BaseAPIClient {
  async getById(labelId) {
    const response = await this.request(getLabel, {
      labelId
    });
    return response.data.label;
  }
  async getBulk() {
    const response = await this.request(listLabels, {});
    return {
      data: response.data.labels
    };
  }
  async create(label) {
    const response = await this.request(createLabel, {
      label
    });
    return response.data.label;
  }
  async update(label) {
    const response = await this.request(updateLabel, {
      label
    });
    return response.data.label;
  }
  async delete(labelId) {
    const response = await this.request(deleteLabel, {
      labelId
    });
    return response.data;
  }
  async query(query) {
    const response = await this.request(queryLabels, {
      query
    });
    return {
      data: response.data.labels,
      pagingMetadata: response.data.pagingMetadata
    };
  }
  async countLabels(filter) {
    const response = await this.request(countLabels, {
      filter
    });
    return response.data.count;
  }
}
//# sourceMappingURL=LabelsClient.js.map